module.exports = __webpack_public_path__ + "static/media/Ivern.dedb397f.png";